export default __webpack_public_path__ + "static/media/1-desktop-popup-image-promo-app.9d54eb16.png";